import { Col, Container, Row, Card, CardBody } from "reactstrap";

import { useHistory } from "react-router-dom";
import {
  FaBlogger,
  FaAddressCard,
  FaMessage,
  FaCity,
  FaListUl,
  FaHotel,
} from "react-icons/fa";
import { MdOutlineReviews } from "react-icons/md";

const SeoContent = () => {
  let history = useHistory();

  const redirectTo = (path) => {
    history.push("/seobook/" + path);
  };

  return (
    <Container className="masters">
      <Row>
        <Col md={12} className="contBody">
          <Card>
            <CardBody>
              <div className="card__title pageNav">
                <div className="bold-text themeColor pad-l-10">SEO Content</div>
              </div>
              <Row style={{ padding: "0 20px 10px 0" }}>
                <Col md={12}>
                  <Row>
                    <Col md={2} className="m_col">
                      <div className="m_icon">
                        <FaListUl
                          style={{ color: "#00B0FC" }}
                          onClick={(e) => redirectTo("urlcontent")}
                        />
                        <div>Url content</div>
                      </div>
                    </Col>
                    <Col md={2} className="m_col">
                      <div className="m_icon">
                        <FaCity
                          style={{ color: "#F55c7A" }}
                          onClick={(e) => redirectTo("citycontent")}
                        />
                        <div>City content</div>
                      </div>
                    </Col>
                    <Col md={2} className="m_col">
                      <div className="m_icon">
                        <FaBlogger
                          style={{ color: "#4682B4" }} // light blue
                          onClick={(e) => redirectTo("blogdata")}
                        />
                        <div>Blog Data</div>
                      </div>
                    </Col>
                    <Col md={2} className="m_col">
                      <div className="m_icon">
                        <FaBlogger
                          style={{ color: "#4682B4" }} // light blue
                          onClick={(e) => redirectTo("blogCategory")}
                        />
                        <div>Blog Categories</div>
                      </div>
                    </Col>
                    <Col md={2} className="m_col">
                      <div className="m_icon">
                        <FaAddressCard
                          style={{ color: "#4682B4" }} // light blue
                          onClick={(e) => redirectTo("blogAuthors")}
                        />
                        <div>Blog Authors</div>
                      </div>
                    </Col>
                    <Col md={2} className="m_col">
                      <div className="m_icon">
                        <FaListUl
                          style={{ color: "#F55c7A" }}
                          onClick={(e) => redirectTo("faqcontent")}
                        />
                        <div>Faq content</div>
                      </div>
                    </Col>
                    <Col md={2} className="m_col">
                      <div className="m_icon">
                        <FaHotel
                          style={{ color: "#F55c7A" }}
                          onClick={(e) => redirectTo("mandapcontent")}
                        />
                        <div>Mandap Content</div>
                      </div>
                    </Col>
                    <Col md={2} className="m_col">
                      <div className="m_icon">
                        <MdOutlineReviews
                          style={{ color: "#F55c7A" }}
                          onClick={(e) => redirectTo("testimonial")}
                        />
                        <div>Testimonials</div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SeoContent;
